export const STORAGE_KEYS = {
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  CODE_VERIFIER: 'CODE_VERIFIER',
  SITE_UNDER_MAINTENANCE: 'SITE_UNDER_MAINTENANCE',
  CAMPAIGN_EID: 'campaignEID-dcm',
  IS_IMPERSONATION: 'IS_IMPERSONATION',
};
